class DreyerCartUpsell extends HTMLElement {
  connectedCallback() {
    this.load();
  }

  async load() {
    const productId = this.dataset.productId;
    if (!productId) return;
    const cartIds = (this.dataset.cartIds || '').split(',');
    try {
      const url = `${this.dataset.url}?section_id=dreyer-cart-upsell&product_id=${productId}&limit=10&intent=related`;
      const response = await fetch(url);
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const candidates = [...doc.querySelectorAll('[data-upsell-item]')].filter(
        (item) => !cartIds.includes(item.dataset.productId)
      );
      const affordable = candidates.filter((item) => Number(item.dataset.price) <= 2000);
      const others = candidates.filter((item) => Number(item.dataset.price) > 2000);
      const items = [...affordable, ...others].slice(0, 2);
      if (!items.length || !this.isConnected) return;
      const list = this.querySelector('[data-upsell-list]');
      items.forEach((item) => list.appendChild(document.importNode(item, true)));
      list.addEventListener('click', (event) => this.onClick(event));
      this.hidden = false;
    } catch (error) {
      console.error(error);
    }
  }

  async onClick(event) {
    const button = event.target.closest('[data-variant-id]');
    if (!button) return;
    const drawer = document.querySelector('cart-drawer');
    button.disabled = true;
    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });
      if (!response.ok) throw new Error('add failed');
      const state = await response.json();
      drawer.renderContents(state);
    } catch (error) {
      console.error(error);
      button.disabled = false;
    }
  }
}

if (!customElements.get('dreyer-cart-upsell')) customElements.define('dreyer-cart-upsell', DreyerCartUpsell);
